import React from "react";
import PageContainer from "../Layout/PageContainer";
import {
  Button,
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  Col,
  Form,
  FormFeedback,
  FormGroup,
  Input,
  InputGroup,
  Label,
  Row,
} from "reactstrap";
import { validateField } from "../../utils";
import bannerService from "../../redux/services/banner.service";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { retrieveGame } from "../../redux/actions/game";
import { debounce } from "lodash";
import { BannerConstants } from "../../shared";
function AddOfferBanner({ currentUser }) {
  const { games: filteredGames } = useSelector((state) => state.game);
  const dispatch = useDispatch();
  const [submitting, setSubmitting] = React.useState(false);
  const [formData, setFormData] = React.useState({
    adId: null,
    offerMainTitle: null,
    offerMainDescription: null,
    offerSeasonText: null,
    bannerType: null,
    voucher: null,
  });
  const [files, setFiles] = React.useState({
    bannerImage: null,
    bannerImage2: null,
  });
  const [search, setSearch] = React.useState("");
  const [debouncedSearch, setDebouncedSearch] = React.useState("");

  // Debounce function
  const debounceSearch = React.useCallback(
    debounce((value) => {
      setDebouncedSearch(value);
    }, 700),
    []
  ); // Adjust debounce time (500ms)

  // Effect to watch search input changes and apply debounce
  React.useEffect(() => {
    debounceSearch(search);
  }, [search, debounceSearch]);

  // Params for API request
  const param = {
    page: 1,
    perPage: 50,
    sort: "createdAt",
    sortType: "desc",
    keyword: debouncedSearch,
  };

  // Fetch data whenever debouncedSearch changes
  React.useEffect(() => {
    dispatch(retrieveGame(param));
  }, [dispatch, debouncedSearch]);

  const [errors, setErrors] = React.useState({});
  // Inside AddOfferBanner Component
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    if (name === "bannerType") {
      // When bannerType changes, reset all other fields to null
      setFormData({
        adId: null,
        offerMainTitle: null,
        offerMainDescription: null,
        offerSeasonText: null,
        bannerType: value, // Keep the new bannerType value
        voucher: null,
      });
    } else {
      // For other fields, update normally
      setFormData((prev) => ({ ...prev, [name]: value }));
    }

    // Validate only if the field is currently rendered
    if (isFieldVisible(name)) {
      setErrors((prev) => ({ ...prev, [name]: validateField(name, value) }));
    }
  };

  const handleFileChange = (event) => {
    const { name, files } = event.target;
    setFiles((prev) => ({ ...prev, [name]: files[0] }));
  };
  const handleSubmit = async (event) => {
    setSubmitting(true);
    event.preventDefault();

    let newErrors = {};
    Object.keys(formData).forEach((key) => {
      if (formData[key]) {
        if (isFieldVisible(key)) {
          const error = validateField(key, formData[key]);
          if (error) newErrors[key] = error;
        }
      }
    });

    setErrors(newErrors);

    try {
      if (Object.keys(newErrors).length === 0) {
        console.log("Form Submitted", formData);

        const formDataWithFiles = new FormData();

        // Append form data
        Object.keys(formData).forEach((key) => {
          if (formData[key]) {
            formDataWithFiles.append(key, formData[key]);
          }
        });
        console.log(files.bannerImage);
        if (files.bannerImage) {
          formDataWithFiles.append("bannerImage", files.bannerImage);
        }
        if (files.bannerImage2) {
          formDataWithFiles.append("bannerImage2", files.bannerImage2);
        }

        await bannerService.createOfferBanner(formDataWithFiles).then(
          (response) => {
            if (response.status === 200) {
              toast.success("Banner Added Successfully");
              setFormData({
                adId: "",
                offerMainTitle: "",
                offerMainDescription: "",
                offerSeasonText: "",
              });
            }
          },
          (error) => {
            toast.error(error.response.data.message);
          }
        );
      }
    } catch (error) {
      console.log(error);
    } finally {
      setSubmitting(false);
    }
  };

  // Function to check if a field is visible
  const isFieldVisible = (fieldName) => {
    if (
      (fieldName === "offerMainDescription" ||
        fieldName === "offerSeasonText" ||
        fieldName === "adId") &&
      (formData.bannerType === BannerConstants.MAINTENANCE ||
        formData.bannerType === BannerConstants.STATIC ||
        formData.bannerType === BannerConstants.TRADE ||
        formData.bannerType === BannerConstants.REDEEM)
    ) {
      return false;
    }
    return true;
  };

  // Form Submit Handler
  //   const handleSubmit = async (event) => {
  //     event.preventDefault();

  //     let newErrors = {};
  //     Object.keys(formData).forEach((key) => {
  //       const error = validateField(key, formData[key]);
  //       if (error) newErrors[key] = error;
  //     });

  //     setErrors(newErrors);

  //     if (Object.keys(newErrors).length === 0) {
  //       console.log("Form Submitted", formData);
  //       // Add API submission logic here
  //       const payload = {
  //         adId: formData.adId,
  //         ...formData,
  //       };
  //       await bannerService.createOfferBanner(payload).then(
  //         (response) => {
  //           if (response.status === 200) {
  //             toast.success("Banner Added Successfully");
  //             setFormData({
  //               adId: "",
  //               offerMainTitle: "",
  //               offerMainDescription: "",
  //               offerSeasonText: "",
  //             });
  //           }
  //         },
  //         (error) => {
  //           toast.error(error.response.data.message);
  //         }
  //       );
  //     }
  //   };
  const status = [
    BannerConstants.MAINTENANCE,
    BannerConstants.STATIC,
    BannerConstants.REDEEM,
    BannerConstants.DISCOUNT,
    BannerConstants.TRADE,
  ];

  const isDiscount = formData.bannerType === BannerConstants.DISCOUNT;
  const isStatic =
    formData.bannerType === BannerConstants.MAINTENANCE ||
    formData.bannerType === BannerConstants.STATIC;
  const isRedeem = formData.bannerType === BannerConstants.REDEEM;
  const isTrade = formData.bannerType === BannerConstants.TRADE;

  function renderPlaceholders(key) {
    switch (key) {
      case BannerConstants.DISCOUNT:
        return "60%";

      case BannerConstants.MAINTENANCE:
        return " Please input maintenance reason ";
      case BannerConstants.STATIC:
        return "This is the moving banner";
      case BannerConstants.REDEEM:
        return "This is the voucher banner";
      case BannerConstants.TRADE:
        return "This is the trade banner";
      default:
        return "Mail title";
    }
  }

  console.log(filteredGames);
  return (
    <PageContainer
      pageTitleIcon="pe-7s-photo icon-gradient bg-plum-plate"
      pageHeading="Add Offer Banner"
      pageSubTitle="Add the Offer Banner"
    >
      <Row>
        <Col md="12">
          <Card className="main-card mb-3">
            <CardHeader className="card-header-sm">
              <div className="card-header-title font-size-lg text-capitalize fw-normal">
                Add a Banner
              </div>
            </CardHeader>
            <Form onSubmit={handleSubmit}>
              <CardBody>
                <Row>
                  {isStatic || isRedeem ? null : (
                    <>
                      <Col md="3">
                        <Label for="search">Search Ad</Label>
                        <InputGroup size="sm" className="mb-3">
                          <Input
                            id="search"
                            type="text"
                            placeholder="Search..."
                            value={search} // If needed, add search state logic
                            onChange={(e) => setSearch(e.target.value)}
                          />
                          <Button
                            color="primary"
                            type="button"
                            onClick={() => setSearch("")}
                          >
                            <i className="pe-7s-close"></i>
                          </Button>
                        </InputGroup>
                      </Col>
                      <Col md="3">
                        <FormGroup>
                          <Label for="adId">Select Ad</Label>
                          <Input
                            type="select"
                            name="adId"
                            id="adId"
                            value={formData.adId}
                            onChange={handleInputChange}
                            invalid={!!errors.adId}
                          >
                            <option value="">Select Ad</option>
                            {filteredGames?.map((game, index) => {
                              return (
                                <option key={index} value={game.publicId}>
                                  {game.gameName} by {game.seller.username}
                                </option>
                              );
                            })}
                            {filteredGames?.length === 0 && (
                              <option value="all">No AD found</option>
                            )}
                          </Input>
                          {errors.adId && (
                            <FormFeedback>{errors.adId}</FormFeedback>
                          )}
                        </FormGroup>
                      </Col>
                    </>
                  )}

                  <Col md="4">
                    <FormGroup>
                      <Label for="offerMainTitle">
                        {isDiscount ? "Enter Discount" : "Main Title"}
                      </Label>
                      <Input
                        type="text"
                        name="offerMainTitle"
                        id="offerMainTitle"
                        placeholder={renderPlaceholders(formData.bannerType)}
                        value={formData.offerMainTitle}
                        onChange={handleInputChange}
                        invalid={!!errors.offerMainTitle}
                      />
                      {errors.offerMainTitle && (
                        <FormFeedback>{errors.offerMainTitle}</FormFeedback>
                      )}
                    </FormGroup>
                  </Col>
                  <Col md="2">
                    <FormGroup>
                      <Label for="selectStatus">Select Banner Type</Label>
                      <Input
                        type="select"
                        name="bannerType"
                        id="selectStatus"
                        value={formData.bannerType}
                        onChange={handleInputChange}
                        invalid={!!errors.bannerType}
                      >
                        <option value="">Select Banner Type</option>
                        {status.map((item) => {
                          return (
                            <option key={item} value={item}>
                              {item.toUpperCase()}
                            </option>
                          );
                        })}
                      </Input>
                      {errors.bannerType && (
                        <FormFeedback>{errors.bannerType}</FormFeedback>
                      )}
                    </FormGroup>
                  </Col>
                </Row>

                {isStatic ? null : (
                  <>
                    <Row>
                      <Col md="3">
                        <FormGroup>
                          <Label for="bannerImage">Banner Image 1</Label>
                          <Input
                            // invalid={bannerUrlErr !== "" ? true : false}
                            type="file"
                            name="bannerImage"
                            id="bannerImage"
                            accept="image/*"
                            onChange={handleFileChange}
                            // innerRef={fileInputRef}
                          />
                        </FormGroup>
                      </Col>
                      {!isTrade ? null : (
                        <Col md="3">
                          <FormGroup>
                            <Label for="bannerImage2">Banner Image 2</Label>
                            <Input
                              type="file"
                              name="bannerImage2"
                              id="bannerImage2"
                              accept="image/*"
                              onChange={handleFileChange}
                              // innerRef={fileInputRef}
                            />

                            {/* {bannerUrlErr !== "" && (
                        <FormFeedback>{bannerUrlErr}</FormFeedback>
                      )} */}
                          </FormGroup>
                        </Col>
                      )}
                      {isRedeem || isDiscount ? null : (
                        <Col md="3">
                          <FormGroup>
                            <Label for="offerSeasonText">Season Text</Label>
                            <Input
                              type="text"
                              name="offerSeasonText"
                              id="offerSeasonText"
                              placeholder="Summer 25"
                              value={formData.offerSeasonText}
                              onChange={handleInputChange}
                              invalid={!!errors.offerSeasonText}
                            />
                            {errors.offerSeasonText && (
                              <FormFeedback>
                                {errors.offerSeasonText}
                              </FormFeedback>
                            )}
                          </FormGroup>
                        </Col>
                      )}
                      {isRedeem ? (
                        <Col md="3">
                          <FormGroup>
                            <Label for="voucher">Voucher</Label>
                            <Input
                              type="text"
                              name="voucher"
                              id="voucher"
                              placeholder="LUCIFER25"
                              value={formData.voucher}
                              onChange={handleInputChange}
                              invalid={!!errors.voucher}
                            />
                            {errors.voucher && (
                              <FormFeedback>{errors.voucher}</FormFeedback>
                            )}
                          </FormGroup>
                        </Col>
                      ) : null}
                    </Row>
                    <Row>
                      {isRedeem || isDiscount ? null : (
                        <Col md="6">
                          <FormGroup>
                            <Label for="offerMainDescription">
                              Banner Description
                            </Label>
                            <Input
                              type="text"
                              name="offerMainDescription"
                              id="offerMainDescription"
                              placeholder="Last chance to win this ..."
                              value={formData.offerMainDescription}
                              onChange={handleInputChange}
                              invalid={!!errors.offerMainDescription}
                            />
                            {errors.offerMainDescription && (
                              <FormFeedback>
                                {errors.offerMainDescription}
                              </FormFeedback>
                            )}
                          </FormGroup>
                        </Col>
                      )}
                    </Row>
                  </>
                )}
              </CardBody>

              <CardFooter className="d-block">
                <Button className="me-2" color="link">
                  Cancel
                </Button>
                <Button
                  disabled={submitting}
                  size="lg"
                  color="primary"
                  type="submit"
                >
                  {submitting ? "Submitting..." : "Add Banner"}
                </Button>
              </CardFooter>
            </Form>
          </Card>
        </Col>
      </Row>
    </PageContainer>
  );
}

export default AddOfferBanner;
